import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Card from './Card';
import Timer from './Timer';
import AnswerOption from './AnswerOption';
import { useGameStore } from '../stores/gameStore';

const CurrentQuestion = ({ onSelectAnswer }) => {
	const { t, i18n } = useTranslation();
	const questionNumber = useGameStore((state) => state.questionNumber);
	const totalQuestions = useGameStore((state) => state.totalQuestions);
	const currentQuestion = useGameStore((state) => state.currentQuestion);
	const timeLeft = useGameStore((state) => state.timeLeft);
	const userLanguage = i18n.language || 'en';

	const [lastAnswer, setLastAnswer] = useState('');
	const [hasAnswered, setHasAnswered] = useState(false);

	useEffect(() => {
		setLastAnswer('');
		setHasAnswered(false);
	}, [currentQuestion]);

	const handleSelect = (answer) => {
		setLastAnswer(answer);
		if (!hasAnswered) {
			setHasAnswered(true);
			onSelectAnswer(answer);
		}
	};

	const handleTimeUp = () => {
		if (!hasAnswered) {
			setHasAnswered(true);
			onSelectAnswer(null);
		}
	};

	if (!currentQuestion) {
		return (
			<Card className='text-center py-12'>
				<h2 className='text-2xl font-bold mb-4'>{t('common.loadingQuestionMessage')}</h2>
				<div className='w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto'></div>
			</Card>
		);
	}

	return (
		<div className='container-game py-8'>
			<div className='flex justify-between items-center mb-4'>
				<div className='text-white font-bold'>
					{t('currentQuestionView.questionProgressLabel', { current: questionNumber, total: totalQuestions })}
				</div>
				<div className='text-white font-medium'>
					{t('currentQuestionView.categoryDisplay', { categoryName: currentQuestion.category })}
				</div>
			</div>
			<Card className='mb-6'>
				<Timer timeLeft={timeLeft} totalTime={currentQuestion.timeLimit} onTimeUp={handleTimeUp} />
				<h2 className='text-xl md:text-2xl font-bold mb-6 text-center'>
					{currentQuestion.questionTexts[userLanguage]}
				</h2>
				<div className='space-y-3'>
					{currentQuestion.options[userLanguage].map((option, index) => (
						<AnswerOption
							key={option}
							option={option}
							index={index}
							onClick={handleSelect}
							selected={lastAnswer === option}
							disabled={hasAnswered}
						/>
					))}
				</div>
			</Card>
			{hasAnswered && (
				<div className='text-center text-white'>
					<p className='text-lg font-medium'>{t('currentQuestionView.answerSubmittedMessage')}</p>
					<p>{t('currentQuestionView.waitingForOtherPlayersMessage')}</p>
				</div>
			)}
		</div>
	);
};

export default CurrentQuestion;
